// extracted by mini-css-extract-plugin
export default {"text":"Heading_text__1+ude"};